import createHistory from 'history/createBrowserHistory';

export default createHistory({
    forceRefresh: true
});


// WEBPACK FOOTER //
// ./src/utility/history.js